import { useState } from "react";

import { useNavigate } from "react-router-dom";

import PageHeader from "../components/PageHeader";
import BannerEditor from "../components/BannerEditor";

import useCategories from "../hooks/useCategories";
import usePosts from "../hooks/usePosts";
import useBanners from "../hooks/useBanners";

export default function CreateBannerPage() {

    const navigate = useNavigate();

    const {
        categories,
    } = useCategories();

    const {
        posts,
    } = usePosts();

    const {
        createBanner,
        saving,
    } = useBanners();

    const [formData, setFormData] = useState({

        title: "",

        message: "",

        cta_text: "",

        cta_url: "",

        placement: "inline",

        category: "",

        blog: "",

        image: null,

        is_active: true,

        starts_at: "",

        ends_at: "",

    });

    const updateField = (field, value) => {

        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));

    };

    const handleSubmit = async () => {

        await createBanner(formData);

        navigate("/admin/banners");

    };

    return (

        <div className="space-y-8">

            <PageHeader
                title="Create Banner"
                subtitle="Advertisement Management"
            />

            <BannerEditor
                formData={formData}
                updateField={updateField}
                categories={categories}
                posts={posts}
            />

            <div className="flex justify-end">

                <button
                    onClick={handleSubmit}
                    disabled={saving}
                    className="
                        px-8
                        py-3
                        rounded-xl
                        bg-blue-800
                        text-white
                        font-semibold
                        hover:bg-blue-600
                        disabled:opacity-60
                    "
                >
                    {saving
                        ? "Creating..."
                        : "Create Banner"}
                </button>

            </div>

        </div>

    );

}